import React, { Component } from 'react'

import PropTypes from 'prop-types'

import Activity from './Activity'
import NoteActivity from '../Notes/NoteActivity'

export default class Activities extends Component {
  static propTypes = {
    onRemoveEvent: PropTypes.func,
    onRemoveNote: PropTypes.func,
    onEditClick: PropTypes.func,
    onTimeEdited: PropTypes.func,
    onNotesClick: PropTypes.func,
    day: PropTypes.shape({
      id: PropTypes.string,
      title: PropTypes.string,
      dayOfTrip: PropTypes.string,
      contentEvents: PropTypes.arrayOf(PropTypes.object)
    })
  }

  render() {
    const { day, onRemoveEvent, onRemoveNote, onEditClick, onTimeEdited, onDateEdited, onNotesClick } = this.props
    if (!day) return null
    return (
      <div>
        {day.ItinerarydayNotes
          ? day.ItinerarydayNotes.map((e, i) => (
              <NoteActivity key={i} data={e} onEditClick={e => onNotesClick(e)} onRemove={id => onRemoveNote(id)} type={'plan-part'} />
            ))
          : ''}
        {day.eventItineraryDays.map((e, i) => (
          <Activity
            key={i}
            data={e.ContentEvent}
            tripStart={this.props.tripStart}
            tripEnd={this.props.tripEnd}
            onTimeEdited={(activity, time) => {
              onTimeEdited(activity, time)
            }}
            onDateEdited={(activity, newDate) => {
              onDateEdited(activity, day, newDate)
            }}
            onEditClick={e => onEditClick(e)}
            onRemove={id => onRemoveEvent(id)}
            type={'plan-part'}
          />
        ))}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/components/TripPlanner/Activities.js